import {
  GET_PRODUCT_IMAGES,
  GET_PRODUCT_IMAGES_SUCCESS,
  GET_PRODUCT_IMAGES_FAIL,
  GET_PRODUCT_IMAGE_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const orderAttachment = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRODUCT_IMAGES:
      return {
        ...state,
        loading: true,
      };
    case GET_PRODUCT_IMAGES_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_PRODUCT_IMAGE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_PRODUCT_IMAGES_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default orderAttachment;
